<template>

<div class="main articles-admin columns one-three-columns">
    <div class="articles-list">
        <ul>
            <nested-list-item v-for="(item, index) in getKBMenu" :item="item" :adminView="true" :key="'kb-menu-item-' + item.kb_item_id"></nested-list-item>
        </ul>
        <router-link tag="button" to="/admin/articles/new" class="button action">New Article</router-link>
        <div class="loading full-page" v-if="loading"><i class="fas fa-spinner fa-spin"></i></div>
    </div>
    <router-view />
</div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NestedListItem from '@/modules/dashboard/components/NestedListItem'
export default {
    name: 'help-center-articles',
    props: [ 'kb_item_id' ],
    components: {
        'nested-list-item': NestedListItem
    },
    data() {
        return {
            loading: false,
            kbMenu: []
        }
    },
    created() {
        this.bootstrap()
    },
    watch: {
        '$route.params.kb_item_id'(newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                // this.bootstrap()
            }
        }
    },
    computed: {
        ...mapGetters('dashboard_module', [
            'getKBMenu'
        ])
    },
    methods: {
        ...mapActions('dashboard_module', [
            'updateLoadingModule',
            'updateKBMenu'
        ]),
        bootstrap() {
            this.loading = true
            this.updateLoadingModule({ value: 'getKbMenu'})
            this.apiCall({ destination: 'get_kb_menu' }).then(obj => {
                this.updateLoadingModule({ value: 'getKbMenu', remove: true })
                this.loading = false
                this.updateKBMenu(obj.kb_menu)
                // this.kbMenu = obj.kb_menu
            }).catch(err => {
                this.updateLoadingModule({ value: 'getKbMenu', remove: true })
                this.loading = false
                console.log(err);
            })
        }
    }
}
</script>

<style>
</style>
